<div class="loadingMapFull" *ngIf="isDataLoading">
  <div class="flex_center fullHeight">
    <mat-spinner [diameter]="30" class="mr-3"></mat-spinner> Please wait while we load
  </div>
</div>
<div class="">
  <!-- <header class="sticky-top sticky-offset" data-spy="scroll" data-offset="50" [hidden]="!showAppNav">
    <div class="container">
      <div class="row">
        <div class="d-md-none d-none"> <img [src]="savedSearchFacade.darkLogo" class="mt-4 mobt-3" width="140" (click)="goToHome();"></div>
        <div class="col-sm-8">
        </div>
      </div>
    </div>
  </header> -->
  <section class="mt-40">
    <div class="container">
      <div class="whiteWrap">
        <div class="titleWrap">
          <div class="row w-100 mx-0">
            <div class="col-sm-8 pl-0">
              <h4 class="mt-3 mb-0">
                <!-- <button (click)="goToHome();" mat-icon-button color="primary" [hidden]="!showAppNav">
                  <mat-icon aria-hidden="false" aria-label="Favorites">home</mat-icon>
                </button> -->
                <!-- <button (click)="goToParentPath()" mat-icon-button color="primary" class="backArrow d-block d-sm-block d-md-none float-left">
                  <i class="material-icons">
                    arrow_back_ios </i> </button> -->
                Saved Searches
              </h4>
            </div>
            <div class="col-sm-4 pr-0 pl-4" *ngIf="!isDataLoading && savedSearchList && savedSearchList.length">
              <mat-form-field class="w-100">
                <mat-label>Search saved searches</mat-label>
                <input matInput (keyup)="applyFilter($any($event.target).value)" placeholder="Search Name, Type" />
              </mat-form-field>
            </div>
          </div>
        </div>
        <div class="wrap_body">
          <div class="mb-3 row">
            <div class="flex_center w-100" *ngIf="!isDataLoading && !savedSearchList?.length">
              <div class="notFound text-center noData">
                <div>
                  <img class="img-fluid" width="60" src="~/../assets/images/notFound.svg" />
                  <h4>No Saved Searches found</h4>
                </div>
              </div>
            </div>
            <div *ngIf="!isDataLoading && savedSearchList && savedSearchList.length" class="col-lg-12 mt-2">
              <div class="" *ngIf="dataSource && dataSource.filteredData && dataSource.filteredData.length !== 0">
                <div>
                  <div class="container px-0">
                    <div class="row">
                      <div class="col-md-4 my-2" *ngFor="let item of savedSearchList$ | async">
                        <app-saved-search-card
                          [item]="item"
                          [editNeeded]="false"
                          (deleteSavedData)="deleteSavedData(item)"
                          (loadSearch)="loadSearch(item)"
                        ></app-saved-search-card>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="flex_center w-100"
                *ngIf="dataSource && dataSource.filteredData && dataSource.filteredData.length === 0"
              >
                <div class="notFound text-center noData">
                  <div>
                    <img class="img-fluid" width="60" src="~/../assets/images/notFound.svg" />
                    <h4>No search result found</h4>
                  </div>
                </div>
              </div>
            </div>
            <mat-paginator [length]="9" [pageSizeOptions]="[9, 24]"> </mat-paginator>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
